<div class="container-fluid header">
    <div class="row align-items-center justify-content-center" style="border-bottom:1px solid #3D3D3D ">
        <div class="col-10">
            <nav class="navbar p-0 navbar-expand-md">
                <a><img class="logo" src="../../../../assets/images/beyondi-logo-mint-white.svg" /></a>

                <div class="row connectWalletContainer" *ngIf="isConnected && isMetamask">
                    <!-- <div class="mr-3">
                        <button
                            nbButton
                            status="primary"
                            size="small"
                            (click)="onApplyForDemo()"
                        >
                            APPLY FOR A DEMO
                        </button>
                    </div> -->
                    <div class="mr-3">
                        <nb-select shape="semi-round" size="small" placeholder="Select crowdsale"
                            (selectedChange)="onChangeCrowdsale($event)" [selected]="contractAddress">
                            <nb-option *ngFor="
                                    let savedCrowdsale of crowdsaleHelperService.savedCrowdsales$
                                        | async
                                " value="{{ savedCrowdsale.contractAddress }}">{{ savedCrowdsale.name }}</nb-option>
                        </nb-select>
                        <button class="ml-3" nbButton size="small" status="primary" shape="semi-round"
                            (click)="onAddCrowdsale()">
                            ADD A CROWDSALE
                        </button>
                    </div>
                    <div *ngIf="isConnected && isMetamask">
                        <div class="dropdown">
                            <button nbButton class="dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" size="small"
                                shape="semi-round">
                                {{ walletName }}
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <p class="dropdown-item m-0" (click)="onViewMyTransactions()">
                                    My transactions
                                </p>
                                <p class="dropdown-item m-0" (click)="logout()">
                                    Disconnect wallet
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="connectWalletContainer" *ngIf="!isConnected">
                    <button nbButton status="primary" class="btn connectWalletBtn mr-3" (click)="openDialog()" size="small">
                        <span class="walletText">Connect wallet</span>
                        <img class="walletImg" src="../../../../assets/images/book-outline.svg" alt="" />
                    </button>
                    <div *ngIf="isConnected && !isMetamask">
                        <button (click)="(logout)" nbButton status="danger" class="row btn connectWalletBtn ml-2">
                            Disconnect
                        </button>
                    </div>
                </div>

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#toggleNav"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                    style="color: white">
                    <span class="fas fa-bars fa-1x"></span>
                </button>

                <div class="collapse navbar-collapse" id="toggleNav">
                    <ul class="navbar-nav ml-2 mr-auto">
                        <!-- <li class="nav-item" *ngIf="contractAddress">
                            <a class="nav-link" (click)="navigateHome()">Home</a>
                        </li>
                        <li class="nav-item" *ngIf="contractAddress">
                            <a class="nav-link">Pricing</a>
                        </li> -->

                        <li class="nav-item dropdown" *ngIf="
                                contractAddress &&
                                (crowdsaleHelperService.crowdsaleData$ | async)
                                    ?.staticPages.length != 0
                            ">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Info
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                <a class="dropdown-item" href="/{{ contractAddress }}/info#{{
                                        page.slug
                                    }}" *ngFor="
                                        let page of (
                                            crowdsaleHelperService.crowdsaleData$
                                            | async
                                        )?.staticPages
                                    ">{{ page.title }}</a>
                            </div>
                        </li>
                        <li *ngIf="
                                walletAddress ==
                                '0x33c387551e5ca235b06c59093209ac32afa9ef07'
                            " class="nav-item">
                            <a href="/token-release" class="nav-link">Token release</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>